import { render } from "./Person.vue?vue&type=template&id=6eede155&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"

import "./Person.vue?vue&type=style&index=0&id=6eede155&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eede155"]])

export default __exports__